import TagManager from "react-gtm-module";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Auth from "./pages/auth";
import ErrorPage from "./pages/error";
import Home from "./pages/home";
import Settings from "./pages/settings";
import Sign from "./pages/sign";

function isUUID(id: string) {
  const uuidPattern =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return uuidPattern.test(id);
}
function App() {
  const searchParams = new URLSearchParams(window.location.search);
  const id = searchParams.get("id");
  const pathname = process.env.REACT_APP_PATHNAME;
  const gtag = process.env.REACT_APP_GTAG;
  const screenWidth = window.innerWidth;
  const url = window.location.search;

  if (process.env.NODE_ENV === "production" && gtag) {
    TagManager.initialize({ gtmId: gtag, dataLayer: { screenWidth, url } });
  }

  return (
    <Router>
      <Routes>
        <Route
          path={`${pathname}`}
          element={
            id && isUUID(id) ? <Home /> : <Navigate to={`${pathname}error`} />
          }
        />
        <Route
          path={`${pathname}sign`}
          element={
            id && isUUID(id) ? <Sign /> : <Navigate to={`${pathname}error`} />
          }
        />
        <Route
          path={`${pathname}auth`}
          element={
            id && isUUID(id) ? <Auth /> : <Navigate to={`${pathname}error`} />
          }
        />
        <Route path={`${pathname}error`} element={<ErrorPage />} />
        <Route
          path={`${pathname}settings`}
          element={
            id && isUUID(id) ? (
              <Settings />
            ) : (
              <Navigate to={`${pathname}error`} />
            )
          }
        />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}

export default App;
